import { ActionTypes as action } from "./action-types";
import _ from "lodash";
import { getDefaultState } from "./state";

const mutations = {
    [action.GET_STATISTICS_DATA](state, data) {
        state.statisticsData = data;
    },
    [action.GET_USER_LIST](state, data) {
        state.userList = data;
    },
    [action.GET_ROLE_LIST](state, data) {
        state.roleList = data;
    },
    [action.GET_ROLE_BY_ID](state, data) {
        state.roleDetails = data;
    },
    [action.GET_USER_BY_ID](state, data) {
        state.userDetails = data;
    },
    [action.GET_ACTIVITY_LIST](state, data) {
        if (state.activitylogs.length) {
            state.activitylogs = state.activitylogs.concat(data)
        } else {
            state.activitylogs = data;
        }
    },
    [action.GET_TOTAL_ACTIVITY_COUNT](state, count) {
        state.totalCount = count;
    },
    [action.SET_ACTIVITY_FILTER](state, data) {
        state.activityFilter = data;
    },

    [action.RESET_ACTIVITY_LIST](state, data) {
        state.activitylogs = data;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, getDefaultState())
    },
    [action.SET_TENANT_GROUP_DATA](state, data) {
        state.tenantGroupingList = data;
    },
};

export default mutations;
